import * as React from "react";

export function MyCard({ header, body }: { header: React.ReactNode; body: React.ReactNode }) {
  return (
    <section className="card">
      {header ? <div className="card-h">{header}</div> : null}
      <div className="card-b">{body}</div>
    </section>
  );
}
